// Provider Documentation Coach Module (Módulo F — BillingV2)
// Feedback educativo por provider: specificity, MEAT y HCC no documentados.

import ProviderDocCoachPage from "./pages/ProviderDocCoachPage";

// Export routes for AppRouter
export const providerDocCoachRoutes = [
  {
    path: "/provider-doc-coach",
    element: <ProviderDocCoachPage />,
  },
];

// Export components for external use
export { default as ProviderDocCoachPage } from "./pages/ProviderDocCoachPage";

// Export utilities
export * from "./common/constants";
